<script>
import axios from "axios";

export default {
  name: "items-list",
  data() {
    return {
      itemId: "",
      postComments: [],
    }
  },
  methods: {
    itemClicked(id) {
      console.log("Item clicked: " + id)
      this.itemId = id;
      this.showPost();
    },
    showPost() {
      $(`#CreatorModal${this.itemId}`).modal("show");
      this.getComments();
    },

    async getComments() {
      try {
        const res = await axios.get(`/item/${this.itemId}/comments`);
        this.postComments = res.data.comments;
      } catch (e) {
        notify(
            "error",
            "Something went wrong, please check your Internet and try again."
        );
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>

</style>